import React, {  } from "react";
import { Toaster } from "react-hot-toast";
//  landing page sections
import Reporting from "./reporting-section/Reporting";
import Testimonials from "./testinomials/Testimonials";
import Brands from "./brands-section/Brands";

import Contact from "../Contact/Contact";
import FeaturesOverview from "./features/FeaturesOverview";
import WhyInggage from "./whyInggage/WhyInggage";
import home_video from "../../assets/video/home_video.mp4"; // Replace with your video path
import Faqs from "./FAQS/Faqs";
import { motion } from "framer-motion";
//import Vector from "../../assets/Vector.png";

const LandingPage = () => {

  

  return (
    <>
      <Toaster />
      {/* Section 1 - Hero Section */}
      <div className="relative w-full overflow-hidden bg-white text-center">
        {/* Background Video */}
        <video
          className="absolute top-0 left-0 w-full h-full object-cover z-[10] "
          autoPlay
          loop
          muted
          playsInline
        >
          <source src={home_video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Dark Overlay */}
        <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50 z-10"></div>

        {/* Content */}
        <motion.div
          className="relative z-20 flex flex-col items-center justify-center my-10 px-4 py-16"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <motion.div
            className="mb-4"
            style={{ fontFamily: "Gilroy-Light" }}
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.7 }}
          >
            <h1 className="text-3xl md:text-5xl font-bold leading-snug text-white">
              The Future of Influencer Marketing is Here!
            </h1>
          </motion.div>

          <motion.p
            className="text-lg md:text-lg text-white mb-8 max-w-2xl"
            style={{ fontFamily: "Gilroy-Medium" }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.7 }}
          >
            Say goodbye to overpriced influencer deals. AI-Powered influencer
            marketing that delivers real engagement & performance-based payments
            for brands & creators.
          </motion.p>

          <motion.div
            className="flex"
            style={{ fontFamily: "Gilroy-Bold" }}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.6, duration: 0.5 }}
          >
            <button className="bg-white hover:bg-pink-700 text-black text-sm px-4 py-2 rounded-full mb-10">
              Book a Demo
            </button>
          </motion.div>
        </motion.div>
      </div>

      {/* why inggage */}
      <WhyInggage />

      {/* Features overview */}
      <FeaturesOverview />
      {/* Brands Animation Section */}
      <Brands />

      {/* Advanced reporting Section */}
      <Reporting />

      {/* Testimonials */}
      <Testimonials />

      {/* Newsletter-section */}

      {/* Faqs */}
      <Faqs />

      {/* Scrolls */}

      <Contact />
    </>
  );
};

export default LandingPage;
